import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { _ } from 'underscore';
import { FilterPipe } from 'ngx-filter-pipe';
import { NgxAlertsService } from '@ngx-plus/ngx-alerts';

@Component({
  selector: 'idg-searchbar',
  templateUrl: './searchbar.component.html',
  styleUrls: ['./searchbar.component.scss']
})
export class SearchbarComponent implements OnInit {

  //#region Vriable Zone
  strValue;
  @Input('dataList') dataList: any;
  @Output() itemClick: EventEmitter<any> = new EventEmitter();
  ServiceList: any;
  strFilter;
  //#endregion

  constructor(
    private filters: FilterPipe,
    private alert: NgxAlertsService,
  ) { 
    
  }

  ngOnInit() {
    
  }

  //#region Functions Utility Zone
  filter(str: any) {
    this.strValue = str;
    if(str){
      this.ServiceList = this.filters.transform(this.dataList, { 'ServiceName': str});
    } else {
      this.ServiceList = null;
    }
  }

  onItemClick(item: any){
    this.ServiceList = null;
    this.itemClick.emit(item);
  }

  onServiceLock(){
    this.alert.alertWarning({title: `
      <h1>Forbidden</h1>
      <div>You don't have permission to access on this service.</div>
    `});
  }
  //#endregion

}
